import React, { useState, useEffect } from "react";
import IdentityVaultTab from "./IdentityVaultTab";
import MonitoringInfo from "./MonitoringInfo/MonitoringInfo";
import SocialMediaMonitoring from "./MonitoringInfo/SocialMedia/SocialMediaMonitoring";
import DarkWebFinancialAccountList from "./MonitoringInfo/FinancialAccount/DarkWebFinancialAccountList";
import { useAreServicesActive } from "../../util/CommonServices";
import { idfServiceIds, ezsServiceIds } from "../../config/UserServicesList";
import ErrorBoundary from "../common/ErrorBoundary";
import CreditBureauInformation from "./MonitoringInfo/CreditBureauInformation/CreditBureauInformation";
import { useSelector, useDispatch } from "react-redux";
import { ApplicationState } from "../../store";
import { MonitoringData } from "../../store/common";
import * as services from "../../store/service";
import * as ConfigurationActions from "../../store/configurationService/actions";
import { setTimeout } from "timers";
import LogoContainer from "../common/LogoContainer";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

const MonitoredInfo = (props: any) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [isLoading, setisLoading] = useState(true);
    const [monitoringData, setMonitoringData] = useState({} as MonitoringData);
    const socialDetailQuery = new URLSearchParams(window.location.search);
    const isIDFUser = useSelector((state: ApplicationState) =>
        state.myAccountServiceState && state.myAccountServiceState.isIdfUser ? state.myAccountServiceState.isIdfUser : false
    );
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const { t: tLang } = useTranslation();
    const socialMediaMonitors = useSelector((state: ApplicationState) => state.monitorData && state.monitorData.monitorData);
    // Start Active service base UI Display Logic
    const ids = [
        idfServiceIds.darkWebMonitoring,
        idfServiceIds.smartSSNTracker,
        idfServiceIds.smartSsnTracker,
        idfServiceIds.childCreditActivityMonitoring,
        idfServiceIds.socialMediaMonitoring,
        idfServiceIds.changeOfAddressMonitoring,
        idfServiceIds.shortTermLoanMonitoring,
        ezsServiceIds.socialMediaMonitoring,
        ezsServiceIds.darkWebMonitoring,
        ezsServiceIds.darkWebPhiBot,
        ezsServiceIds.publicRecordsMonitoring,
        ezsServiceIds.courtRecordsMonitoring,
        ezsServiceIds.changeOfAddressMonitoring,
        ezsServiceIds.basicPublicRecordsMonitoring,
        ezsServiceIds.tuCriminalMonitoring,
        // ezsServiceIds.tuIDPMonitoring, // TU - IDP (Public Records) Bundle [After discussing with Terri, regarding bug #31069 and #29359,
        // for now exclude the "SVC-TU-IDP" service from the list of services who are responsible to enable the MonitoringInfo tab]
        ezsServiceIds.sexOffenderMonitoring,
        ezsServiceIds.paydayLoansMonitoring,
        ezsServiceIds.smartSSNTrackerAdult,
        ezsServiceIds.smartSSNTrackerChild,
        ezsServiceIds.businessDarkWebMonitoring,
        ezsServiceIds.tuAdvancedFraudMonitoring,
        ezsServiceIds.tuChangeOfAddressMonitoring,
        ezsServiceIds.tuSSNMonitoring,
        ezsServiceIds.tuCanadaCreditMonitoring,
        ezsServiceIds.oneBureauCreditMonitoring,
        ezsServiceIds.tuOneBureauCreditMonitoring,
        ezsServiceIds.tuOneBureauCreditMonitoringBasic,
        ezsServiceIds.tuThreeBureauCreditMonitoring,
        ezsServiceIds.tuThreeBureauCreditMonitoringBasic,
        ezsServiceIds.tuCreditLock,
        ezsServiceIds.tuCreditLockI,
        ezsServiceIds.tuCreditLock3b,
        ezsServiceIds.tuCreditLock3bI,
        ezsServiceIds.tuIDPMonitoring,
        ezsServiceIds.tuAnnualCreditReport,
        ezsServiceIds.tuAnnualCreditReportWithScore,
        ezsServiceIds.tuAnnualCreditScore,
        ezsServiceIds.tuDailyCreditReport,
        ezsServiceIds.tuDailyCreditReportWithScore,
        ezsServiceIds.tuDailyCreditScore,
        ezsServiceIds.tuMonthlyCreditReport,
        ezsServiceIds.tuMonthlyCreditReportWithScore,
        ezsServiceIds.tuMonthlyCreditScore,
        ezsServiceIds.tuCreditReport,
        ezsServiceIds.tuCreditReportWithScore,    
        ezsServiceIds.tuOneTimeCreditReportWithScore,
        ezsServiceIds.tuQuarterlyCreditReport,
        ezsServiceIds.tuQuarterlyCreditReportWithScore,
        ezsServiceIds.tuQuarterlyCreditScore,
        ezsServiceIds.tuAnnualCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuAnnualCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuMonthlyCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuMonthlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuQuarterlyCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuQuarterlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuCreditScoreSimulator,
        ezsServiceIds.tuCreditScoreTracker,
    ];
    const isMonitoringActive = useAreServicesActive(ids);
    const isSocialMediaMonitoringActive = useAreServicesActive([idfServiceIds.socialMediaMonitoring, ezsServiceIds.socialMediaMonitoring]);
    const [isSocialMonitoringServiceActiveInPlan, setIsSocialMonitoringServiceActiveInPlan] = useState(false);
    const packageInformationData: any = useSelector((state: ApplicationState) => state.packageUpgradeState?.packageInformationData);
    const isDWMActive = useAreServicesActive([idfServiceIds.darkWebMonitoring, ezsServiceIds.darkWebMonitoring, ezsServiceIds.businessDarkWebMonitoring]);
    const isCreditBureauInformationActive = useAreServicesActive([
        ezsServiceIds.businessCreditServiceBusinessCredit,
        ezsServiceIds.businessCreditServiceBusinessCreditPro,
        ezsServiceIds.businessCreditServiceBusinessCreditSelect,
    ]);
    const isLife360PartnerId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 539
                ? true
                : false
            : false
    );

    // End

    const isBusinessUser = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userServiceDetails && state.loggedInUser.userServiceDetails.isBusinessUser
            ? state.loggedInUser.userServiceDetails.isBusinessUser
            : false
    );

    const setSocialPackageState = (packagesServices: any) => {
        for (var i = 0; i <= packagesServices.length - 1; i++) {
            if (packagesServices[i]["service-key"] && packagesServices[i]["service-key"] === "social-media-monitoring") {
                setIsSocialMonitoringServiceActiveInPlan(true);
            }
        }
    };

    const ensureDataFetched = () => {
        setisLoading(true);

        services
            .getMonitoring()
            .then((getMonitoringResponse) => {
                setisLoading(false);
                setMonitoringData({ asset: getMonitoringResponse.asset });
            })
            .catch(function (error) {
                setisLoading(false);
            });

        if (isIDFUser) {
            let packagesServices = packageInformationData["data"];

            //Bug-27921: hide social media if not found in protection plans for switched accounts
            if (packagesServices) {
                setSocialPackageState(packagesServices);
            } else {
                services
                    .getPackagesUpgradeDowngrade()
                    .then((data) => {
                        data = JSON.parse(data);
                        packagesServices = data["data"];
                        setSocialPackageState(packagesServices);
                    })
                    .catch(function (error) {});
            }
        }
    };

    useEffect(() => {
        const initialUrl = window.location.href;
        sessionStorage.setItem("initialUrl", encodeURIComponent(initialUrl));
        ensureDataFetched();
    }, []);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    useEffect(() => {
        setTimeout(() => {
            if (props.history.location.hash.includes("#social-media-accounts")) {
                document.getElementById("social-media-accounts") &&
                    document.getElementById("social-media-accounts")!.scrollIntoView({ block: "center", behavior: "smooth" });
            }
        }, 500);
    }, [monitoringData]);

    const network = socialDetailQuery.get("network")!;

    useEffect(() => {
        if (network) {
            history.push({
                pathname: "/identity-vault#social-media-accounts",
                search: "",
            });
            setTimeout(() => {
                window.close();
            }, 3 * 60000);
            if (socialMediaMonitors && socialMediaMonitors.length) {
                setTimeout(() => {
                    window.close();
                }, 60000);
            }
        }
    }, [network, socialMediaMonitors]);

    useEffect(() => {
        if (!isMonitoringActive) {
            history.push("/identity-vault/secure-storage");
        }
    }, []);

    return (
        <React.Fragment>
            <div className=" row">
                <div className="col-xs-12 row">
                    <h1 className="title-page">{tLang("identityVault.title")}</h1>
                    <LogoContainer internalPage={true} />
                </div>
            </div>
            {isMonitoringActive && (
                <>
                    <IdentityVaultTab selectedTab="1" />
                    {
                        <div className="row">
                            <ErrorBoundary componentName="MonitoringInfo" type="showError" replaceDefaultContent={false} errorMsg="">
                                <MonitoringInfo monitoringData={monitoringData} />
                            </ErrorBoundary>
                        </div>
                    }
                    <div className="row" id="content">
                        <div className="col-xs">
                            <ErrorBoundary componentName="DarkWeb" type="showError" replaceDefaultContent={false} errorMsg="">
                                {/* Display only if service is active*/}
                                {isDWMActive && !isLife360PartnerId && <DarkWebFinancialAccountList />}
                            </ErrorBoundary>
                        </div>
                    </div>
                    {/* after accounts, social media monitoring  -> Story 66435 */}
                    <div className="row" id="content">
                        <div className="col-xs">
                            {/* Display only if service is active*/}
                            <ErrorBoundary componentName="SocialMediaMonitoring" type="showError" replaceDefaultContent={false} errorMsg="">
                                {(!isIDFUser || isSocialMonitoringServiceActiveInPlan) && isSocialMediaMonitoringActive && <SocialMediaMonitoring />}
                            </ErrorBoundary>
                        </div>
                    </div>
                    {/* Display only if business user*/}
                    {isBusinessUser &&
                        isCreditBureauInformationActive &&
                        monitoringData.asset && ( // @TODO - same here, should still show this if no data, but gives error if wrap only creditbureauInfo
                            <div className={`row ${isLoading && "loading"}`} id="content">
                                <div className="col-xs">
                                    <ErrorBoundary componentName="CreditBureauInformation" type="showError" replaceDefaultContent={false} errorMsg="">
                                        <CreditBureauInformation monitoringData={monitoringData} />
                                    </ErrorBoundary>
                                </div>
                            </div>
                        )}
                </>
            )}
        </React.Fragment>
    );
};

export default MonitoredInfo;
